import axios from 'axios';

export default {
    fetchForYear(year) {
        return axios.post('/leaveGeneral/fetchLeaveForYear/', { year });
    },
    remove(id) {
        return axios.post('/leaveGeneral/deleteLeave/', { id });
    },
    update(id, date, name) {
        return axios.post('/leaveGeneral/updateLeave/', { id, date, name });
    },
    add(date, dateEnd, name) {
        return axios.post('/leaveGeneral/addLeave/', { date, dateEnd, name });
    },
};
